registerComponent("modals/modal-docs", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Quem abre este modal é o `templates/footer` e, desde 16/09 (ADR 0047), o
 * `templates/footer-redesign` em toda página, com o nome da aba (`documentos`,
 * `regulatorios`, `disclaimer`, `public_offers`). Em 2020 o nome vinha no
 * segundo argumento de `$modalDocs.trigger('open', [alvo])`; agora vem em
 * `event.detail` de um `CustomEvent`.
 *
 * A rolagem trava por `Asa.travarRolagem`, a mesma trava do modal "Abrir conta"
 * — `body.modal-opened` só tem regra sob `body.legado`, e nas páginas do design
 * não há `body.legado`. A classe continua: é ela que baixa o header de 2020 para
 * debaixo do modal.
 */

const TRAVA = 'modal-docs';

const btnsClose = component.querySelectorAll('.btn-close');
const alvos = component.querySelectorAll('[data-target]');

// Tagueamento (plano v3.1): a aba aberta e quando, para o `modal_close`.
let abaAberta = '';
let abertoEm = 0;

component.addEventListener('open', /** @param {CustomEvent<string>} event */ function (event) {
    abaAberta = String(event.detail || '');
    abertoEm = Date.now();
    Asa.track('modal_open', { modal_name: `docs_${abaAberta}`, origin: 'footer', method: 'click' });

    document.body.classList.add('modal-opened');
    component.classList.add('active');
    Asa.travarRolagem(TRAVA);

    alvos.forEach(function (alvo) {
        alvo.style.display = 'none';
    });

    const escolhido = component.querySelector(`[data-target="${event.detail}"]`);

    /*
     | `display: block`, não `''`. O `.show()` do jQuery só devolve o valor
     | inline anterior quando existe um; aqui `[data-target]` nasce
     | `display: none` PELA FOLHA (_modal-docs.less), então o jQuery caía no
     | display padrão da tag — `block` para uma `div`. Com `''` o modal abriria
     | com a moldura e sem conteúdo nenhum, e sem erro no console.
     */
    if (escolhido) {
        escolhido.style.display = 'block';
    }
});

btnsClose.forEach(function (botao) {
    botao.addEventListener('click', function () {
        Asa.track('modal_close', { modal_name: `docs_${abaAberta}`, method: 'x', seconds: Math.round((Date.now() - abertoEm) / 1000) });

        document.body.classList.remove('modal-opened');
        component.classList.remove('active');
        Asa.soltarRolagem(TRAVA);
    });
});

});
